import React from "react";
import "../Style/topbar.css";

function TopBar() {
  return (
    <div className="topbar">
      <div className="tb_logo">
        <a href="/"> ₦AIRALAND FORUMS</a>
      </div>
      <div className="tb_mid">
        Welcome, <b>Guest</b>:{" "}
        <a href="/register">
          <b>Register on Nairaland</b>
        </a>{" "}
        <span> / </span> <a href="/login">LOGIN!</a> <span> / </span>{" "}
        <a href="/trending">Trending</a>
        <span> / </span> <a href="/new">Recent</a> <span> / </span>{" "}
        <a href="/new">New</a>
      </div>
      <div className="tb_down">
        <b>Stats</b> : 3,124,293 members, 7,713,519 topics. <b>Date</b> :
        {new Date().toLocaleString().replace(",", "")}
      </div>
      <div className="tb_bottom">
        <input type="text" name="" id="" readOnly />
        <button>Search</button>
      </div>
    </div>
  );
}

export default TopBar;
